module.exports = __webpack_public_path__ + "media/tk-sound-navidad-2022.4722aa06.ogg";